import { ArrowRight } from 'lucide-react';
import { _t } from '@/i18n/t';
import MarcoAvatar from './MarcoAvatar';
import type { PopularRoute } from './hooks/useAssistantConfig';

interface AssistantWelcomeProps {
  firstName?: string | null;
  popularRoutes: PopularRoute[];
  onRouteSelect: (message: string) => void;
}

const AssistantWelcome = ({ firstName, popularRoutes, onRouteSelect }: AssistantWelcomeProps) => {
  const name = firstName?.trim();
  const intro = name
    ? _t('assistant.welcome.introNamed', { name })
    : _t('assistant.welcome.introAnonymous');

  return (
    <div className="flex flex-col items-center px-2 py-3 text-center" data-testid="assistant-welcome">
      <MarcoAvatar className="h-[88px] w-[88px]" />

      <p className="mt-3 text-page-heading tracking-tight text-foreground">
        {_t('assistant.name')}
      </p>
      <p className="mt-2 text-[12px] text-muted-foreground">{_t('assistant.welcome.fullName')}</p>

      <p className="mt-4 text-[13px] leading-relaxed text-foreground">{intro}</p>

      {popularRoutes.length > 0 && (
        <>
          <p className="mt-5 text-[10px] font-semibold uppercase tracking-[0.12em] text-muted-foreground">
            {_t('assistant.welcome.popularRoutes')}
          </p>

          <ul className="mt-3 flex w-full list-none flex-col gap-2 p-0">
            {popularRoutes.map((route) => (
              <li key={route.label}>
                <button
                  type="button"
                  onClick={() => onRouteSelect(route.message)}
                  data-th-button="true"
                  className="flex w-full items-center gap-3 rounded-xl border border-border bg-card px-3.5 py-2.5 text-left text-[13px] text-foreground transition-colors hover:border-primary/40 hover:bg-secondary"
                >
                  <ArrowRight className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
                  <span className="min-w-0 flex-1">{route.label}</span>
                </button>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default AssistantWelcome;
